import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const UserItemRow = styled.li`
  position: relative;
  display: flex;
  height: auto;
  min-height: 88px;
  padding: 8px 9px 8px 8px;
  border-top: 1px solid ${COLORS.line};
  border-radius: 4px;
  transition: background-color 0.15s ease-out;

  &:first-child {
    border-top: none;
  }

  &:last-child {
    border-bottom: 1px solid ${COLORS.line};
  }

  &:hover {
    background-color: ${COLORS.gray04};
    border-color: transparent;
    border-radius: 4px;
  }

  &:hover + li {
    border-top: 1px solid transparent;
  }

  ${({ selected }) => selected && `
      background-color: ${COLORS.line}
  `}
`;

export default UserItemRow;
